import * as d3 from 'd3';
import $ from 'jquery';

import {getPromise} from 'util/Net';
import {serialize} from 'util/SVGTools';
import {postJSONPromise} from 'util/TaskRunner';

export const SOLID_LINE = '1,0'; // solid line has no space between "dashes"
export const DASHED_LINE = '5,5'; // dashed line has equally sized dashes and spaces

export async function getPNGFileForSVG(svg: SVGSVGElement, filename: string): Promise<string> {
  const fontSVG = await getPromise('/static/fonts/inconsolata-400.svg');
  const fontNode = $(fontSVG).find('font');
  const fontFace = fontNode.find('font-face');
  fontFace.attr('font-family', 'Inconsolata').attr('font-weight', 400);
  fontNode.find('glyph:not([d])').remove();

  // Prevent browser from caching CSS when the build changes
  const rawCSS: string = await getPromise(`/static/build/svg.css?r=${window.REVISION}`);
  const css = rawCSS.split('\n').join('').split('\r').join('');

  return postJSONPromise({
    url: '/1/api/svg-to-png',
    data: {
      filename,
      svg: serialize(svg, css, fontNode.get(0) as unknown as SVGElement),
    },
  });
}

export function getSVGHeight(svg: SVGSVGElement): number {
  return parseInt(d3.select(svg).attr('height'), 10);
}

export function appendSVGToSVG({
  parentSVG,
  childSVG,
  transform,
}: {
  parentSVG: SVGSVGElement;
  childSVG: SVGSVGElement;
  transform: string;
}): void {
  // Convert child SVG to a G and append it to the parent SVG.
  const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  d3.select(g).attr('class', d3.select(childSVG).attr('class'));
  $(g).append($(childSVG).children());
  d3.select(g).attr('transform', transform);
  $(parentSVG).append(g);
}

export function fixAxis(svg: SVGSVGElement): void {
  // HACK(saif): inkscape can't handle em's, so we convert them to pixels.
  d3.select(svg)
    .selectAll('.tick')
    .selectAll('text')
    .each(function fixAxisText() {
      const em = parseFloat(d3.select(this).attr('dy'));
      const dy = em * 11;
      d3.select(this).attr('dy', dy);
    });
}
